module.exports = __webpack_public_path__ + "img/approve.3aff9c58.svg";